import React, { Fragment, useMemo, useCallback, useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import  { Controller,Navigation, Scrollbar, Pagination } from 'swiper';
import Moment from "moment";
import { isMobile } from "react-device-detect";
import {calcurateDday, discountRate, setClickLogapi} from "helpers";
import {isObjectEmpty} from "typeHelpers";
import { RES_DOMAIN, SHOPFREECA_DOMAIN } from "constant/config";

const ShopfreecaSection = ({ loading= false, shopfreeca={}}) => {

    const { broadcast_live = {}, curation_product = [] } = shopfreeca;

    const prefBtnRef = useRef(null);
    const nextBtnRef = useRef(null);

    // 숲토어 홈 클릭 로그 전달
    const handleShopfreecaClickLog = useCallback((button_type) => {
        setClickLogapi("station_click", {button_group : "shopfreeca_home", button_type : button_type, bj_id: global.bj_id } );
    }, []);


    // 숲토어 큐레이션 상품 렌더링
    const _renderCurationSlide = useCallback((broadcast_live, curation_product, isCuration, key) => {

        /**
         * 보정사항 
         * 1. 맨 마지막 더보기 버튼 2.5개
         */

        // 라이브 커머스 상품
        const {
            campaign_no = 0,
            coming_soon_thumbnail = '\/\/res.afreecatv.com/images/afmain/img_thumb_profile.gif',
            coming_soon_url= '',
            is_show = 0,
            is_show_product_info = 1,
            main_bj_id = '',
            main_bj_nick = '',
            main_product_no = 0,
            on_air_start_date='0000-00-00 00:00:00',
            on_air_end_date='0000-00-00 00:00:00',
            show_host_name='',
            title = '',
            time = '',
        } = broadcast_live;


        // 큐레이션 상품 정의
        const {
            product_no = 0,
            product_name = '',
            image_url = '\/\/res.afreecatv.com/images/afmain/img_thumb_profile.gif',
            original_price = 0,
            discount_price = 0,
            charge = 0,
            reg_datetime = '',
            update_datetime = '',
            product_type='' 
        } = curation_product;

        /* 할인율 0% 일 경우에는 원가만 노출 */
        const discount_rate = discountRate(original_price, discount_price);
        const product_price = discount_rate > 0 ? original_price - discount_price : original_price;

        // 이미지 없으면 아프리카 이미지 default 라도 띄워야할거 같은데
       return (
           <SwiperSlide
                tag={'li'}
                className={!isCuration ? 'live' : ''}
                key={key}
            >
                <a href={ isCuration ? SHOPFREECA_DOMAIN + "/products/" +  product_no + "?stationId=" + global.bj_id : coming_soon_url }
                   onClick={() => handleShopfreecaClickLog(isCuration ? (product_type === "marpple" ? product_type : "normal") : "live")} target="_blank"
                >
                    <div className="thumb">
                        <img src={isCuration ? image_url : coming_soon_thumbnail} alt="" />
                        {!isCuration && (
                            <div className="dday">
                                <em>{calcurateDday(broadcast_live)}</em>
                            </div>
                        )}
                    </div>

                    <div className="thumb_blur" style={{backgroundImage:`url("${ isCuration ? image_url : coming_soon_thumbnail}")` }} />
                    <div className="detail">
                        <p className="tit">{isCuration ? product_name : title}</p>

                        { isCuration ? (
                            <div className="price_wrap">
                                {/* 할인율 0% 일 경우에는 원가만 노출 */}
                                {discount_rate > 0 && ( <span className="per">{discount_rate}%</span> )}
                                <strong>{product_price.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}<i>원</i></strong>
                                {discount_rate > 0 && (<del>{original_price} 원</del>)}
                            </div>
                        ): (
                            <strong className="time">{Moment(on_air_start_date).format("YY.MM.DD HH:mm")} 방송 시작</strong>
                        )}

                    </div>
                </a>
        </SwiperSlide>
       );
    }, [handleShopfreecaClickLog]);

    // 채널 홈 더보기 버튼 슬라이드 추가
    const _renderMoreSlide = useCallback(() => {
        
        if ( Object.keys(broadcast_live).length > 0  && curation_product.length <= 0) return null;

        return (
            isMobile ? null : (
                <SwiperSlide
                    tag={'li'}
                    className={'more_wrap'}
                >
                    <a href={`/${global.bj_id}/shopfreeca`} className="more"><span>더보기</span></a>
                </SwiperSlide>
            )

        );
    }, [broadcast_live, curation_product]);


    if (loading) {
        return null;
    } else {
        if (!isObjectEmpty(broadcast_live) || !isObjectEmpty(curation_product)) {

            const swiperSettings = {
                slidesPerView : isMobile ? 1 : 2.5,
                id : "shop_item_wrap",
                className : "shop_item_wrap",
                modules : [Controller, Navigation, Scrollbar, Pagination],
                wrapperTag : "ul",
                initialSlide : 0,
                navigation: { // 네비게이션 적용, < >
                    prevEl : prefBtnRef.current,
                    nextEl : nextBtnRef.current,
                },
                pagination: { clickable : true, el: '.swiper-pagination', type: 'bullets' },
                //pagination: true,
                scrollbar : isMobile ? { draggable: true, el: '.swiper-pagination' } : {},
                spaceBetween: 16,
            }


            return (
                // shop_prev
                // shop_next
                // PC 8개 모바일 5개
                // <a href="" class="more"><span>더보기</span></a>
                <Fragment >
                    <div className="shopfreeca_wrap">
                        <h3 className="ic">
                            <a href={`/${global.bj_id}/shopfreeca`}>숲토어</a>
                        </h3>
                        <Swiper
                            {...swiperSettings}
                        >

                            {  // 슬라이드 '라이브 커머스'
                                !isObjectEmpty(broadcast_live) &&
                                _renderCurationSlide(broadcast_live, {}, false, 0)
                            }
                            {
                                // 슬라이드 '숲토어 큐레이션'
                                curation_product.map((item, idx) => {
                                    return (
                                        _renderCurationSlide({}, item, true, idx + 1)
                                    );
                                })
                            }
                            {
                                // 슬라이드 '더보기' 버튼
                                _renderMoreSlide()
                            }
                        </Swiper>

                        <span className="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
                        {/* 이전 버튼 누를때 2.5개 정도로 안보임*/}
                        {
                            isMobile ? (
                                // 모바일일 경우 슬라이딩
                                <div className="swiper-pagination"></div>
                            ) : (
                                // PC일 경우 네비게이션 버튼
                                <Fragment>
                                    <button type="button" ref={prefBtnRef} className="shop_prev" tabIndex="0"
                                            aria-disabled="false">이전
                                    </button>
                                    <button type="button" ref={nextBtnRef} className="shop_next" tabIndex="10"
                                            aria-disabled="false">다음
                                    </button>
                                </Fragment>)
                        }
                    </div>
                </Fragment>

            );
        }
    }

    return null;
};


export default ShopfreecaSection;
